<template>
    <div id="dlXlsx">
        <!-- <el-button type="primary" @click="setXlsx(sheet, head, data)">下载数据</el-button> -->
        <!-- <span class="downEx" style="cursor: pointer;" @click="setXlsx(sheet, head, data)">导出表格</span> -->
        <span class="downEx" style="cursor: pointer;" @click="openExportDialog">导出表格</span>
        <!-- 导出前选择要排除的部门 -->
        <el-dialog v-model="dialogVisible" title="导出数据 - 排除部门" width="480px" :close-on-click-modal="false" append-to-body>
            <div v-loading="deptLoading" element-loading-text="正在获取部门列表...">
                <div class="dept-tip">勾选需要<b>排除</b>的部门，不勾选则导出全部部门数据</div>
                <div class="dept-actions">
                    <el-checkbox :model-value="isCheckAll" :indeterminate="checkedBmbms.length > 0 && checkedBmbms.length < deptList.length" @change="checkAllChange">全选</el-checkbox>
                    <span class="dept-count">已选 {{ checkedBmbms.length }} / {{ deptList.length }}</span>
                </div>
                <div class="dept-empty" v-if="deptLoaded && deptList.length == 0">未获取到部门数据</div>
                <el-checkbox-group v-else v-model="checkedBmbms" class="dept-list">
                    <el-checkbox v-for="item in deptList" :key="item.bmbm" :label="item.bmbm">{{ item.bmmc }}</el-checkbox>
                </el-checkbox-group>
            </div>
            <template #footer>
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" :loading="exporting" @click="confirmExport">导 出</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import xlsx from '@/common/xlsx'
import model from '../../views/course/model/model'
import _ from 'lodash'
var that = null
export default {
    props: {
        livingId: {
            type: String,
        },
        bmbm: {
            type: String,
        },
        livetype: {
            type: String,
        },
        // 部门类型（与页面URL的type一致，透传给部门列表接口）
        type: {
            type: String,
            default: '',
        },
        // 当前登录用户信息（含bmbm，用于拉取部门列表，与组别数据页保持一致）
        userInfo: {
            type: Object,
            default: null,
        },
        // sheet: {
        //     type: Array,
        // },
        // head: {
        //     type: Array,
        // },
        // data: {
        //     type: Array,
        // },
    },
    computed: {
        isCheckAll() {
            return (
                that.deptList.length > 0 &&
                that.checkedBmbms.length === that.deptList.length
            )
        },
    },
    data() {
        that = this
        return {
            dialogVisible: false, // 排除部门弹窗显隐
            deptLoading: false, // 部门列表加载中
            deptLoaded: false, // 部门列表是否已加载成功（避免重复请求）
            deptList: [], // 本场直播参与的部门列表 [{bmbm, bmmc}]
            checkedBmbms: [], // 已勾选要排除的部门编码（关闭弹窗不清空，下次导出回显）
            exporting: false, // 导出请求中
            line: {
                down: {
                    sheet: ['员工数据'],
                    head: [],
                    list: [],
                },
            },
        }
    },
    methods: {
        /**
         * 点击导出：
         * - 单个部门（bmbm 非空）：保持原有行为，直接导出
         * - 合计/全部部门（bmbm 为空）：先弹窗勾选要排除的部门
         */
        openExportDialog() {
            if (that.bmbm) {
                that.doExport([])
                return
            }
            that.dialogVisible = true
            if (!that.deptLoaded) {
                that.loadDeptList()
            }
        },
        /**
         * 拉取本场直播参与的部门列表（与组别数据页 getList 一致：type=1）
         */
        loadDeptList() {
            that.deptLoading = true
            var userBmbm =
                that.userInfo && that.userInfo.bmbm ? that.userInfo.bmbm : ''
            var params = {
                livingid: that.livingId,
                bmbm: userBmbm,
                type: 1,
                pageIndex: 1,
                pageSize: 50,
            }
            model.get_e_live_bm(params, that.type, that.livetype, userBmbm).then(
                function (res) {
                    that.deptLoading = false
                    if (res.code == 0 && res.list) {
                        var list = []
                        res.list.forEach(function (item) {
                            // 过滤合计行
                            if (item.bmmc == '合计') return
                            // 「其他」行后端编码为 --，导出接口实际使用 hjsy1_qt
                            var code = item.bmbm == '--' ? 'hjsy1_qt' : item.bmbm
                            if (!code) return
                            list.push({
                                bmbm: code,
                                bmmc: item.bmmc == '--' ? '其他' : item.bmmc,
                            })
                        })
                        that.deptList = list
                        that.deptLoaded = true
                        // 剔除缓存勾选中已不存在的部门
                        var codes = list.map(function (v) {
                            return v.bmbm
                        })
                        that.checkedBmbms = that.checkedBmbms.filter(function (
                            v
                        ) {
                            return codes.indexOf(v) > -1
                        })
                    } else {
                        that.$message.error('获取部门列表失败')
                    }
                },
                function () {
                    that.deptLoading = false
                    that.$message.error('获取部门列表失败')
                }
            )
        },
        /**
         * 全选/取消全选
         */
        checkAllChange(val) {
            that.checkedBmbms = val
                ? that.deptList.map(function (v) {
                      return v.bmbm
                  })
                : []
        },
        /**
         * 弹窗内确认导出：带上勾选的排除部门
         */
        confirmExport() {
            that.doExport(that.checkedBmbms)
        },
        /**
         * 执行导出
         * @param {Array} excludeBmbms 要排除的部门编码数组（单个部门导出时为空数组）
         */
        doExport(excludeBmbms) {
            var par = {
                livingid: that.livingId,
                bmbm: that.bmbm,
                livetype: that.livetype,
            }
            if (excludeBmbms && excludeBmbms.length > 0) {
                par.IV_exclude_bmbm = excludeBmbms.join(',')
            }
            that.exporting = true
            model.e_live_bm_export(par).then(
                (res) => {
                    console.log(res)
                    that.exporting = false
                    that.dialogVisible = false
                    that.line.down.head = [
                        '客户昵称',
                        '客户头像',
                        '是否新客户',
                        '是否退出',
                        '直播观看时长',
                        '回看时长',
                        '累计观看时长',
                        '第一次观看时间',
                        '首次进入时间',
                        '最近进入时间',
                        '评论数',
                    ]
                    that.line.down.list = res.list.map((v) => ({
                        wx_nickname: v.wx_nickname,
                        wx_avatar: v.wx_avatar,
                        user_x: v.user_x,
                        out: v.out == 1 ? '是' : '否',
                        his_learning_time:
                            Math.round(v.his_learning_time / 60) + '分钟',
                        his_learned_time:
                            Math.round(v.his_learned_time / 60) + '分钟',
                        his_learn_time:
                            Math.round(v.his_learn_time / 60) + '分钟',
                        first_min_time: v.first_min_time,
                        first_in_time: v.first_in_time,
                        last_in_time: v.last_in_time,
                        comment_num: v.comment_num,
                    }))
                    that.setXlsx(
                        that.line.down.sheet,
                        that.line.down.head,
                        that.line.down.list
                    )
                    // that.get_e_live_list()
                    // this.HideSetDate()
                },
                (error) => {
                    that.exporting = false
                    that.$message.error('获取导出数据异常！')
                }
            )
        },
        setXlsx(sheet, head, data) {
            var Sheets = [],
                List = [],
                Heads = [],
                li = [] // sheets工作簿 名称，list数据 对象数组，heads 头部标题
            Sheets.push(sheet)
            Heads.push(head)

            _.forEach(data, function (v) {
                var obj = new Object()
                obj = v
                li.push(obj)
            })
            List.push(li)

            var ExeclConfig = {
                SheetName: sheet,
                data: {
                    Head: Heads, // 头部标题 如只有一个 就全一样
                    Sheets: Sheets, //工作薄 名称
                    List: List, //数据 对象数组
                },
            }
            console.log(ExeclConfig)
            // return
            xlsx.toExecl(ExeclConfig)
        },
    },
}
</script>

<style scoped>
.dept-tip {
    font-size: 13px;
    color: #909399;
    margin-bottom: 10px;
}
.dept-actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 6px;
    padding: 0 2px;
}
.dept-count {
    font-size: 12px;
    color: #909399;
}
.dept-list {
    display: flex;
    flex-direction: column;
    max-height: 320px;
    overflow: auto;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    padding: 8px 12px;
}
.dept-list .el-checkbox {
    display: flex;
    height: 30px;
    align-items: center;
}
.dept-empty {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    padding: 20px 0;
    text-align: center;
    color: #909399;
    font-size: 13px;
}
</style>
